import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const outboundPaymentIdParameter = 'outbound-payment-id' as const;
export const visibleOutboundPaymentDetailsParameter = 'visible' as const;
const outboundPaymentDetailsParams = [
  outboundPaymentIdParameter,
  visibleOutboundPaymentDetailsParameter,
] as const;

type OutboundPaymentDetailsParams =
  (typeof outboundPaymentDetailsParams)[number];
export type OutboundPaymentDetailsHtmlParams = Partial<
  Record<OutboundPaymentDetailsParams, string>
>;

export const OutboundPaymentDetailsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "outboundPaymentDetails" */ '../../../components/OutboundPaymentDetails/OutboundPaymentDetails'
    ),
  enabledKey: 'internal',
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  htmlAttributes: {
    [outboundPaymentIdParameter]: {
      isInternal: true,
    },
    [visibleOutboundPaymentDetailsParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['close'],
  customHtmlElementMethods: {
    setOutboundPaymentId: {
      type: 'AttributeSettingMethod',
      attribute: outboundPaymentIdParameter,
      isInternal: true,
      description:
        'Sets the outbound payment id to display details for. This must be a valid outbound payment id (e.g., obp_1244343).',
    },
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: true,
      description:
        'Sets the event listener for when the outbound payment details overlay is closed',
    },
  },
  optionalInlineOverlay: true,
  description:
    'A component that displays outbound payment details and allows connected accounts to submit money management claims for fraudulent payments.',
  friendlyName: 'Outbound Payment Details',
};
